(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elements-footer-illustration"]) return;
  try {
    

        let moving = false,
            landscape = document.querySelector('.landscape-wrapper'),
            textblock = document.querySelector('.landscape-text'),
            startPoint = window.innerHeight * 100 / 100,
            endPoint = window.innerHeight * 30 / 100,
            delta = startPoint - endPoint,
            scrollTimeout;

            let getOpacityIndex = function (elemCoords) {
            if (elemCoords <= startPoint && elemCoords >= endPoint) {
                return (1 - (startPoint - elemCoords) / delta);
            } else if (elemCoords <= endPoint) {
                return 0;
            } else if (elemCoords >= startPoint) {
                return 1;
            }
            };

            let changeBackgroundColor = function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
            let landscapeCoordinates = landscape.getBoundingClientRect().top;
            textblock.style.top = getOpacityIndex(landscapeCoordinates)*100 + '%';
            landscape.style.transform = 'scale(' + (1 + getOpacityIndex(landscapeCoordinates)) + ')';
            }, 0);
        };

            window.addEventListener('scroll', function () {
            changeBackgroundColor();
            });
    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elements-landscape-illustration"] && !Shopify.designMode) return;
  try {
    
    let moving = false,
      block1 = document.querySelector('.fade-top'),
      block1_check = document.getElementsByClassName('fade-top'),
      block2 = document.querySelector('.fade-bottom'),
      stars = document.querySelector('.landscape-stars'),
      startPoint = window.innerHeight * 70 / 100,
      endPoint = window.innerHeight * 30 / 100,
      delta = startPoint - endPoint,
      scrollTimeout,
      color1 = "253,249,242",
      color2 = "237,233,222",
      color6 = "233, 227, 215",
      lines1 = "82,79,69",
      lines2 = "194,128,71",
        // night
      color3 = "248, 151, 106",
      color4 = "127,176,195",
      color5 = "79,89,113",
      lines3 = "42,50,68",
      lines4 = "58,67,87";

    let getOpacityIndex = function (elemCoords) {
      if (elemCoords <= startPoint && elemCoords >= endPoint) {
        return (startPoint - elemCoords) / delta;
      } else if (elemCoords <= endPoint) {
        return 1;
      } else if (elemCoords >= startPoint) {
        return 0;
      }
    };

    let changeBackgroundColor = function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      let block2Coordinates = block2.getBoundingClientRect().top;
      if (block1_check.length > 0) {
        block1.style.background = "linear-gradient(180deg, rgba("+color4+"," + getOpacityIndex(block2Coordinates) + "), rgba("+color4+"," +
        getOpacityIndex(block2Coordinates) + "), rgba("+color4+"," +
        getOpacityIndex(block2Coordinates) + ")), linear-gradient(0deg, rgb("+color1+") 0%, rgb("+color2+") 45%, rgb("+color6+") 100%)";
      }
      block2.style.background = "linear-gradient(180deg, rgba("+color4+"," +
        getOpacityIndex(block2Coordinates) + "), rgba("+color4+"," +
        getOpacityIndex(block2Coordinates) + "), rgba("+color3+"," +
        getOpacityIndex(block2Coordinates) + ")), linear-gradient(180deg, rgb("+color1+") 0%, rgb("+color2+") 45%, rgb("+color2+") 100%)";
      block2.style.setProperty('--linework', 'rgba('+lines3+','+getOpacityIndex(block2Coordinates)+')');
      block2.style.setProperty('--bg', 'rgba('+lines4+','+getOpacityIndex(block2Coordinates)+')');
      stars.style.opacity = getOpacityIndex(block2Coordinates);
    }, 0);
  };

    window.addEventListener('scroll', function () {
      changeBackgroundColor();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-np-collection-banner"]) return;
  try {
    
  ;(function() {
     				let pushState = history.pushState;
     				let replaceState = history.replaceState;

     				history.pushState= function() {
     						pushState.apply(history,arguments);
     						window.dispatchEvent(new Event('pushstate'));
     						window.dispatchEvent(new Event('locationchange'));
     				};

     				history.replaceState= function() {
     						replaceState.apply(history,arguments);
     						window.dispatchEvent(new Event('replacestate'));
     						window.dispatchEvent(new Event('locationchange'));
     				};

     				window.addEventListener('popstate',function() {
     						window.dispatchEvent(new Event('locationchange'))
     				});
     		})();

  } catch(e) { console.error(e); }
})();
})();
